
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Subscribe to events and get real-time alerts for changes'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Webhooks' subtitle='Subscribe to events and get real-time alerts for changes' mdxType="Header" />
    <p>{`Once you have Link with Identity Verification embedded in your app, you should be able to complete an entire session and review it in the dashboard.`}</p>
    <p>{`To complete your integration, you need to add a webhook receiver endpoint to your application.`}</p>
    <p>{`To add a webhook, visit the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/developers/webhooks"
      }}>{`dashboard webhook configuration page`}</a>{` and click `}<strong parentName="p">{`New Webhook`}</strong>{`. Note that this is the only setting used to configure Identity Verification webhook receivers; webhook URLs set via `}<inlineCode parentName="p">{`/link/token/create`}</inlineCode>{` will not be used. `}</p>
    <p>{`You can select which events you want to subscribe to. For Identity Verification, there are three events:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/api/products/identity-verification/#step_updated"
        }}><inlineCode parentName="a">{`STEP_UPDATED`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/api/products/identity-verification/#status_updated"
        }}><inlineCode parentName="a">{`STATUS_UPDATED`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/api/products/identity-verification/#retried"
        }}><inlineCode parentName="a">{`RETRIED`}</inlineCode></a></li>
    </ul>
    <p>{`Enter your webhook receiver endpoint for the webhook you wish to subscribe to and click `}<strong parentName="p">{`Configure`}</strong>{`. Plaid will now send an HTTP POST request to the webhook receiver endpoint every time the event occurs, in both the Sandbox and Production environments. If multiple webhook receiver endpoints are configured for an Identity Verification event, webhooks will be sent to all the configured endpoints. `}</p>
    <h4 {...{
      "id": "event-ordering"
    }}>{`Event ordering`}</h4>
    <p>{`Identity Verification does not guarantee that webhooks will be delivered in any particular order. For example, while the logical ordering of webhooks for an Identity Verification session might look like this:`}</p>
    <ol>
      <li parentName="ol"><inlineCode parentName="li">{`STEP_UPDATED`}</inlineCode>{` The user has started the Identity Verification session and is on the first step`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`STEP_UPDATED`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`STATUS_UPDATED`}</inlineCode>{` The user has reached a terminal state for their session`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`RETRIED`}</inlineCode>{` A retry has been requested for this user, either via the dashboard or via API`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`STEP_UPDATED`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`STEP_UPDATED`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`STATUS_UPDATED`}</inlineCode>{` The retry has been completed`}</li>
    </ol>
    <p>{`you should be prepared to handle these events in any delivery order. For example, consider whether your application will properly handle:`}</p>
    <ul>
      <li parentName="ul">{`A `}<inlineCode parentName="li">{`STEP_UPDATED`}</inlineCode>{` event being delivered after a `}<inlineCode parentName="li">{`STATUS_UPDATED`}</inlineCode>{` event.`}</li>
      <li parentName="ul">{`A `}<inlineCode parentName="li">{`STEP_UPDATED`}</inlineCode>{` event being delivered before an associated `}<inlineCode parentName="li">{`RETRIED`}</inlineCode></li>
    </ul>
    <p>{`In order to properly handle webhook events being delivered out of order, your application should look up the user's associated session(s) via the `}<inlineCode parentName="p">{`/identity_verification/list`}</inlineCode>{` API.`}</p>
    <h4 {...{
      "id": "webhook-reference"
    }}>{`Webhook reference`}</h4>
    <p>{`For full webhook information, refer to the `}<a parentName="p" {...{
        "href": "/docs/api/products/identity-verification/"
      }}>{`API Documentation`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "event-ordering",
        level: 4,
        title: "Event ordering",
      },
{
        id: "webhook-reference",
        level: 4,
        title: "Webhook reference",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
